export const SPOT_AI_SCREEN_ID = 'spot_ai';
export const SPOT_AI_CLICKED_EVENT = 'spot_ai_clicked';
export const SPOT_AI_SCREEN_VIEW_EVENT = 'screen_view';
export const SPOT_AI_EVENT_VERSION = 1;

export type SpotAiScreenViewName =
	| 'spot_ai_landing'
	| 'spot_ai_import'
	| 'spot_ai_analyze'
	| 'spot_ai_result'
	| 'spot_ai_error_limits_reached'
	| 'spot_ai_error_private_account'
	| 'spot_ai_error_generic';

export type SpotAiClickAction =
	| 'start_import'
	| 'share_result'
	| 'click_signup'
	| 'click_retry';

type SpotAiScreenIdentity = {
	screen_view_id_type: 'page' | 'score';
	screen_view_id: string;
};

export type SpotAiAnalyticsIdentifiers = {
	dzrUniqueId: string;
	userId: string | null;
};

export type SpotAiScreenViewProperties = SpotAiScreenIdentity &
	Readonly<{
		screen_view_name: SpotAiScreenViewName;
		dzr_unique_id: string;
		user_id: string | null;
	}>;

export type SpotAiClickProperties = SpotAiScreenViewProperties &
	Readonly<{
		action: SpotAiClickAction;
	}>;

type ScreenPayloadInput = SpotAiAnalyticsIdentifiers & {
	screenViewName: SpotAiScreenViewName;
	score?: number | null;
};

type ClickPayloadInput = ScreenPayloadInput & {
	action: SpotAiClickAction;
};

const getScreenIdentity = (
	screenViewName: SpotAiScreenViewName,
	score?: number | null,
): SpotAiScreenIdentity => {
	if (
		screenViewName === 'spot_ai_result' &&
		typeof score === 'number' &&
		Number.isFinite(score)
	) {
		return {
			screen_view_id_type: 'score',
			screen_view_id: String(score),
		};
	}

	return {
		screen_view_id_type: 'page',
		screen_view_id: SPOT_AI_SCREEN_ID,
	};
};

export const canTrackScreenView = (
	screenViewName: SpotAiScreenViewName,
	score?: number | null,
): boolean =>
	screenViewName !== 'spot_ai_result' ||
	(typeof score === 'number' && Number.isFinite(score));

export const buildScreenViewProperties = ({
	screenViewName,
	score,
	dzrUniqueId,
	userId,
}: ScreenPayloadInput): SpotAiScreenViewProperties => ({
	screen_view_name: screenViewName,
	...getScreenIdentity(screenViewName, score),
	dzr_unique_id: dzrUniqueId,
	user_id: userId,
});

export const buildClickProperties = ({
	action,
	...screenInput
}: ClickPayloadInput): SpotAiClickProperties => ({
	...buildScreenViewProperties(screenInput),
	action,
});
